import { useState } from 'react'
import { supabase } from '../supabase'

export default function NewEventForm({onClose,onCreated,orgId}){
  const [name, setName] = useState('')
  const [artist, setArtist] = useState('')
  const [date, setDate] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit() {
    setLoading(true)
    const { error } = await supabase.from('events').insert([{
      name: name,
      artist_name: artist,
      event_date: date,
      status: 'inquiry',
      org_id: orgId
    }])
    setLoading(false)
    if (error) { alert('Error: ' + error.message) } else { onCreated() }
  }

  return (
    <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'white',borderRadius:'16px',padding:'2rem',width:'100%',maxWidth:'480px'}}>
        <h2 style={{marginBottom:'1.5rem',fontSize:'20px'}}>New Event</h2>
        <input placeholder='Event name' value={name} onChange={e => setName(e.target.value)} style={{width:'100%',padding:'10px',marginBottom:'12px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box'}}/>
        <input placeholder='Artist name' value={artist} onChange={e => setArtist(e.target.value)} style={{width:'100%',padding:'10px',marginBottom:'12px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box'}}/>
        <input type='date' value={date} onChange={e => setDate(e.target.value)} style={{width:'100%',padding:'10px',marginBottom:'24px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box'}}/>
        <div style={{display:'flex',gap:'12px'}}>
          <button onClick={onClose} style={{flex:1,padding:'10px',border:'1px solid #ddd',borderRadius:'8px',cursor:'pointer',background:'white'}}>Cancel</button>
          <button onClick={handleSubmit} disabled={loading} style={{flex:1,padding:'10px',border:'none',borderRadius:'8px',cursor:'pointer',background:'#1a6b4a',color:'white'}}>{loading ? 'Saving...' : 'Create Event'}</button>
        </div>
      </div>
    </div>
  )
}